export default function Audiences() {
  return (
    <>
      <section className="sec">
        <div className="shell">
          <div style={{ maxWidth: '700px' }}>
            <p className="eyebrow">Two sides, one system</p>
            <h2 className="h-lg" style={{ marginTop: '18px' }}>Built for Players.<br />Powerful for Operators.</h2>
          </div>

          <div className="grid-2 reveal" style={{ marginTop: '56px' }}>
            <div className="panel">
              <div className="panel-head">
                <div className="disp" style={{ fontWeight: '800', fontSize: '24px', letterSpacing: '-.02em' }}>What your players get</div>
                <span className="tag tag-lime">APP</span>
              </div>
              <div className="ability-grid">
                <div className="ability"><i className="bullet"></i>Book a court</div>
                <div className="ability"><i className="bullet"></i>Join an event</div>
                <div className="ability"><i className="bullet"></i>Find a coach</div>
                <div className="ability"><i className="bullet"></i>Manage membership</div>
                <div className="ability"><i className="bullet"></i>Make payments</div>
                <div className="ability"><i className="bullet"></i>View bookings</div>
              </div>

              <div className="mini">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span className="mono" style={{ fontSize: '10px', letterSpacing: '.16em', color: 'var(--ink-4)' }}>SAMPLE BOOKING SCREEN</span>
                  <span className="mono" style={{ fontSize: '10px', letterSpacing: '.16em', color: 'var(--cyan)' }}>3 SLOTS LEFT</span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <div style={{ flex: '1', borderRadius: '8px', padding: '12px 10px', background: 'rgba(255,255,255,.05)', textAlign: 'center' }}>
                    <div className="mono" style={{ fontSize: '12px' }}>17:00</div><div style={{ fontSize: '10.5px', color: 'var(--ink-4)', marginTop: '4px' }}>Court 02</div>
                  </div>
                  <div style={{ flex: '1', borderRadius: '8px', padding: '12px 10px', background: 'rgba(200,255,60,.14)', border: '1px solid rgba(200,255,60,.45)', textAlign: 'center' }}>
                    <div className="mono" style={{ fontSize: '12px', color: 'var(--lime)' }}>18:30</div><div style={{ fontSize: '10.5px', color: 'var(--lime)', marginTop: '4px' }}>Court 04</div>
                  </div>
                  <div style={{ flex: '1', borderRadius: '8px', padding: '12px 10px', background: 'rgba(255,255,255,.05)', textAlign: 'center' }}>
                    <div className="mono" style={{ fontSize: '12px' }}>20:00</div><div style={{ fontSize: '10.5px', color: 'var(--ink-4)', marginTop: '4px' }}>Court 01</div>
                  </div>
                </div>
                <div className="btn btn-primary btn-sm btn-block" style={{ marginTop: '14px', pointerEvents: 'none' }}>Confirm booking</div>
              </div>
            </div>

            <div className="panel">
              <div className="panel-head">
                <div className="disp" style={{ fontWeight: '800', fontSize: '24px', letterSpacing: '-.02em' }}>What your team gets</div>
                <span className="tag tag-outline">CONSOLE</span>
              </div>
              <div className="ability-grid">
                <div className="ability op"><i className="bullet"></i>Manage courts</div>
                <div className="ability op"><i className="bullet"></i>Manage members</div>
                <div className="ability op"><i className="bullet"></i>Manage events</div>
                <div className="ability op"><i className="bullet"></i>Manage payments</div>
                <div className="ability op"><i className="bullet"></i>Track revenue</div>
                <div className="ability op"><i className="bullet"></i>View analytics</div>
              </div>

              <div className="mini">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span className="mono" style={{ fontSize: '10px', letterSpacing: '.16em', color: 'var(--ink-4)' }}>TODAY AT A GLANCE</span>
                  <span className="mono" style={{ fontSize: '10px', color: 'var(--ink-4)' }}>6 COURTS</span>
                </div>
                <div className="grid-3" style={{ gap: '10px', marginTop: '14px' }}>
                  <div style={{ borderRadius: '9px', background: 'rgba(255,255,255,.04)', padding: '14px' }}><div className="kpi" style={{ fontSize: '24px' }}>38</div><div style={{ fontSize: '11px', color: 'var(--ink-4)', marginTop: '2px' }}>Bookings</div></div>
                  <div style={{ borderRadius: '9px', background: 'rgba(255,255,255,.04)', padding: '14px' }}><div className="kpi" style={{ fontSize: '24px', color: 'var(--cyan)' }}>92%</div><div style={{ fontSize: '11px', color: 'var(--ink-4)', marginTop: '2px' }}>Utilization</div></div>
                  <div style={{ borderRadius: '9px', background: 'rgba(255,255,255,.04)', padding: '14px' }}><div className="kpi" style={{ fontSize: '24px' }}>4</div><div style={{ fontSize: '11px', color: 'var(--ink-4)', marginTop: '2px' }}>Coaching</div></div>
                </div>
                <div style={{ marginTop: '14px', display: 'flex', alignItems: 'flex-end', gap: '5px', height: '62px' }}>
                  <div className="bar" style={{ flex: '1', height: '32%', background: '#4C7DFF' }}></div><div className="bar" style={{ flex: '1', height: '46%', background: '#4C7DFF' }}></div>
                  <div className="bar" style={{ flex: '1', height: '38%', background: '#4C7DFF' }}></div><div className="bar" style={{ flex: '1', height: '64%', background: '#4C7DFF' }}></div>
                  <div className="bar" style={{ flex: '1', height: '82%', background: '#4C7DFF' }}></div><div className="bar" style={{ flex: '1', height: '100%', background: '#4C7DFF' }}></div>
                  <div className="bar" style={{ flex: '1', height: '88%', background: '#4C7DFF' }}></div><div className="bar" style={{ flex: '1', height: '54%', background: '#4C7DFF' }}></div>
                </div>
                <div className="mono" style={{ fontSize: '9.5px', color: 'var(--ink-5)', marginTop: '8px', letterSpacing: '.1em' }}>BOOKINGS BY HOUR &mdash; 08:00 TO 22:00</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
